import React from 'react';

function Journals() {
  return <div>Journals</div>;
}

export default Journals;
